export * from './IconSmileStroked';
